export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-course-content.vue?vue&type=template&id=05f8b722&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-course/lk-course-content/lk-course-content.vue?vue&type=template&id=05f8b722&
// module id = 1205
// module chunks = 0